<div class="d-flex align-items-center justify-content-between mb-3">
    <div class="body-1 pl-4 ml-4">
        <span [ngStyle]="{'color': ticketCombo.controls.length > 0 ?'#35821F':''}">{{ticketCombo.controls.length}}</span> 
        Option Added</div>
    <button
        class="btn btn--paybee modal-success-button"
        (click)="addTicketCombo()"
        style="background-color: #35821F !important;"
    >Add To Combo Ticket</button>
</div>
<ng-container [formGroup]="option">
    <div class="list-wrapper combo" *ngIf="ticketCombo.controls.length !== 0">
        <ul class="list-group ui-sortable" formArrayName="ticketCombo">
            <li class="list-group-item" style="border-bottom:1px solid #ECEDF0 !important;" *ngFor="let ticket of ticketCombo.controls;index as i;">
                <div class="preset-option d-flex">
                    <div class="preset-option__content d-flex align-items-center">
                        <div class="preset-option__container d-flex flex-column pl-4" >
                            <div class="preset-option__name mb-1 subtitle-2 d-flex align-items-center">
                                {{getTicketComboName(ticket) | async}}
                                <div [innerHTML]="getTicketComboQuantity(ticket, true)" class="ml-2"></div>
                                    <div *ngIf="!ticket.value.enforceInventory" class="ml-auto mr-auto">Enforce Inventory: OFF</div>
                                    <div *ngIf="ticket.value.enforceInventory" class="ml-auto mr-auto">Enforce Inventory: ON</div>
                            </div>
                            <div class="caption">
                                <span>Quantity <span class="grey-text">{{getTicketComboQuantity(ticket)}}</span></span> | <span>Campaign <span class="grey-text">{{getTicketComboCampaignName(ticket) | async}}</span></span>
                            </div>
                        </div>
                        <div class="preset-option__actions">
                            <div class="preset-option__action">
                                <app-icon-pen (click)="editTicketCombo(ticket.value, i)"></app-icon-pen>
                            </div>
                            <div class="preset-option__action" (click)="removeTicket(i)">
                                <app-icon-trash></app-icon-trash>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</ng-container>